import { render } from "./BLItemForm.vue?vue&type=template&id=c18c9c26"
import script from "./BLItemForm.vue?vue&type=script&lang=js"
export * from "./BLItemForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__